import { type MatrixEvent } from "matrix-js-sdk/src/matrix";

import { type Preview } from "./Preview";
import { type TagID } from "../../room-list-v3/skip-list/tag";
import { getSenderName, isSelf, shouldPrefixMessagesIn } from "./utils";
import { _t } from "../../../languageHandler";

export class LegacyCallHangupEvent implements Preview {
    public getTextFor(event: MatrixEvent, tagId?: TagID): string {
        if (shouldPrefixMessagesIn(event.getRoomId()!, tagId)) {
            if (isSelf(event)) {
                return _t("event_preview.m_call_hangup.you");
            } else {
                return _t("event_preview.m_call_hangup.user", { senderName: getSenderName(event) });
            }
        } else {
            return _t("timeline.m_call_hangup.dm");
        }
    }
}
